import { useEffect } from 'react';

import { useSearchParameters } from '@/components/signup/hooks/use-search-parameters.tsx';
import { useScreenManager } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-screen-manager';
import type { UserSegmentationTeamTypes } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/models/user-segmentation';
import { isTeamTypeWithTemplateChoice } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/utils/screen-manager/utils';

import { JiraOverlayShim } from '../../views/onboarding-wizard/wizard/jira-overlay-shim';

import { TemplateChoiceViewBase } from './template-choice-view';

export const TwcTemplateChoiceView = () => {
	const { skipScreen } = useScreenManager();
	const { teamType } = useSearchParameters();

	const shouldSkipScreen = !isTeamTypeWithTemplateChoice(teamType);

	useEffect(() => {
		if (shouldSkipScreen) {
			skipScreen();
		}
	}, [shouldSkipScreen, skipScreen]);

	if (shouldSkipScreen) {
		return null;
	}

	return (
		<JiraOverlayShim>
			<TemplateChoiceViewBase
				contextSelectedTeamTypeState={teamType as UserSegmentationTeamTypes}
			/>
		</JiraOverlayShim>
	);
};
